import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

import { TournamentResultVO } from "../../../gamevo/TournamentResultVO";

export class Poker2SitnGoResultDialogProperties extends BasicDialogProperties {
    public tournamentResultVO: TournamentResultVO;

    constructor(tournamentResultVO: TournamentResultVO) {
        super();

        this.tournamentResultVO = tournamentResultVO;
    }
}
